import React, { useState } from 'react';
import { ProfileOverlay } from '../ProfileOverlay/ProfileOverlay';
import { BaseCol } from '@app/components/common/BaseCol/BaseCol';
import { BaseRow } from '@app/components/common/BaseRow/BaseRow';
import { BasePopover } from '@app/components/common/BasePopover/BasePopover';
import { useAppSelector } from '@app/hooks/reduxHooks';
import { useResponsive } from '@app/hooks/useResponsive';
import { BaseAvatar } from '@app/components/common/BaseAvatar/BaseAvatar';
import { isProfessionalFisherSelector } from '@app/store/slices/userSlice';
import { NetListModal } from '@app/components/professionalFisher/NetList/NetListModal';
import * as S from './ProfileDropdown.styles';

import { ReactComponent as ProfileDefault } from '@app/assets/icons/profile.svg';
import { themeObject } from '@app/styles/themes/themeVariables';

const size = 40;

export const ProfileDropdown: React.FC = () => {
  const { isTablet } = useResponsive();

  const theme = useAppSelector((state) => state.theme.theme);
  const { userData } = useAppSelector((state) => state.user);
  const isProfessionalFisher = useAppSelector(isProfessionalFisherSelector);

  const [isPopoverOpen, setIsPopoverOpen] = useState(false);
  const [isNetListVisible, setIsNetListVisible] = useState(false);

  const handleNetListClick = () => {
    setIsPopoverOpen(false);
    setIsNetListVisible(true);
  };

  return userData != null ? (
    <>
      <BasePopover
        content={<ProfileOverlay showNetList={isProfessionalFisher} onNetListClick={handleNetListClick} />}
        trigger="click"
        open={isPopoverOpen}
        onOpenChange={setIsPopoverOpen}
      >
        <S.ProfileDropdownHeader as={BaseRow} gutter={[10, 10]} align="middle">
          <BaseCol>
            {'imgUrl' in userData ? (
              <BaseAvatar src={(userData.imgUrl as string) ?? ''} alt="User" shape="circle" size={size} />
            ) : (
              <ProfileDefault
                width={size}
                height={size}
                fill={themeObject[theme as keyof typeof themeObject].textMain}
              />
            )}
          </BaseCol>
          {isTablet && (
            <BaseCol>
              <span>{`${userData.firstname} ${userData.lastname ? userData.lastname[0] : ''}`}</span>
            </BaseCol>
          )}
        </S.ProfileDropdownHeader>
      </BasePopover>
      {isProfessionalFisher && <NetListModal isVisible={isNetListVisible} onClose={() => setIsNetListVisible(false)} />}
    </>
  ) : null;
};
